export const fonts = {
  BentonSansWideRegular: "BentonSansWideRegular",
  BentonSansWideMedium: "BentonSansWideMedium",
  BentonSansWideBlack: "BentonSansWideBlack",
  BentonSansWideBold: "BentonSansWideBold",
  BentonSansBold: "BentonSansBold",
  BentonSansMedium: "BentonSansMedium",
  BentonSansRegular: "BentonSansRegular",
  Canela: "Canela",
  IvyprestoDisplay: "ivypresto-display, serif",
};
